import { render, staticRenderFns } from "./AdminWardsAdd.vue?vue&type=template&id=9c92d986&"
import script from "./AdminWardsAdd.vue?vue&type=script&lang=js&"
export * from "./AdminWardsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports